import googleAdLogo from '../../public/assets/static/images/googleadsicon.png'
import metaLogo from '../../public/assets/static/images/metaicon.png'
import shopifyLogo from '../../public/assets/static/images/shopifyicon.png'
import deltaxLogo from '../../public/assets/static/images/deltax.png'
import googleAnalyticLogo from '../../public/assets/static/images/googleanalyticsicon.png'
import googleMerchantCenter from '../../public/assets/static/images/googlemerchantcenter.png'
import snapchatLogo from '../../public/assets/static/images/snapchaticon.png'
import appsFlyerLogo from '../../public/assets/static/images/appsflyer.png'
import { Field, RulesJson, Toggle } from '@/types/ProductInsights'
import { getDateString } from '@/helpers/dateHelper'

export enum Operators {
  None = 0,
  Equals = 1,
  NotEquals = 2,
  LessThan = 3,
  LessThanOrEquals = 4,
  GreaterThan = 5,
  GreaterThanOrEquals = 6,
  Contains = 7,
  NotContains = 8,
  IsNull = 9,
  IsNotNull = 10,
  Between = 11,
  IN = 12,
  NotIN = 13,
  ExistsIn = 14,
  NotExistsIn = 15
}

export enum ProductInsightFields {
  None = 0,
  ProductVariantSKU = 1,
  ProductVariantTitle = 2,
  ProductVariantImageLink = 3,
  ProductBrand = 4,
  ProductType = 5,
  ProductVariantStatus = 6,
  ProductVariantColor = 7,
  ProductVariantGender = 8,
  ProductVariantMaterial = 9,
  ProductVariantAvailability = 10,
  ProductVariantCustomLabel1 = 11,
  ProductVariantCustomLabel2 = 12,
  ProductVariantPattern = 13,
  ProductCategory = 14,
  ProductVariantCurrency = 15,
  ProductVariantSize = 16,
  ProductPrice = 17,
  PDFPurchases = 18,
  PDFRevenue = 19,
  PDFMGoal0 = 20,
  PDFMGoal1 = 21,
  PDFMGoal2 = 22,
  PDFMGoal3 = 23,
  PDFMGoal4 = 24,
  PDFMGoal5 = 25,
  PDFMGoal6 = 26,
  PDFMGoal7 = 27,
  PDFMGoal8 = 28,
  PDFMGoal9 = 29,
  PDFMGoal10 = 30,
  PDFMGoal11 = 31,
  PDFMGoal12 = 32,
  PDFMGoal13 = 33,
  PDFMGoal14 = 34,
  PDFMGoal15 = 35,
  PDFMGoal16 = 36,
  PDFMGoal17 = 37,
  PDFMGoal18 = 38,
  PDFMGoal19 = 39,
  PDFMGoal20 = 40,
  PDFMGoal21 = 41,
  PDFMGoal22 = 42,
  PDFMGoal23 = 43,
  PDFMGoal24 = 44,
  PDFMGoal25 = 45,
  PDFMGoal26 = 46,
  PDFMGoal27 = 47,
  PDFMGoal28 = 48,
  PDFMGoal29 = 49,
  PDFMGoal30 = 50,
  PDFMGoal31 = 51,
  PDFMGoal32 = 52,
  PDFMGoal33 = 53,
  PDFMGoal34 = 54,
  PDFMGoal35 = 55,
  PDFMGoal36 = 56,
  PDFMGoal37 = 57,
  PDFMGoal38 = 58,
  PDFMGoal39 = 59,
  PDFMGoal40 = 60,
  PDFMGoalValue11 = 61,
  PDFMGoalValue12 = 62,
  PDFMGoalValue13 = 63,
  PDFMGoalValue14 = 64,
  PDFMGoalValue15 = 65,
  PDFMGoalValue16 = 66,
  PDFMGoalValue17 = 67,
  PDFMGoalValue18 = 68,
  PDFMGoalValue19 = 69,
  PDFMGoalValue20 = 70,
  PDFMStage1 = 71,
  PDFMStage2 = 72,
  PDFMStage3 = 73,
  PDFMStage4 = 74,
  PDFMStage5 = 75,
  PDFMStage6 = 76,
  PDFMStage7 = 77,
  PDFMStage8 = 78,
  PDFMStage9 = 79,
  PDFMStage10 = 80,
  PDFMStage11 = 81,
  PDFMStage12 = 82,
  PDFMStage13 = 83,
  PDFMStage14 = 84,
  PDFMStage15 = 85,
  PDFMStage16 = 86,
  PDFMxConversionsWeb = 87,
  PDFMxConversionsIos = 88,
  PDFMxConversionsAndroid = 89,
  PDFMxRevenueWeb = 90,
  PDFMxRevenueAndroid = 91,
  PDFMxRevenueIos = 92,
  FMClicks = 93,
  FMImpressions = 94,
  FMCost = 95,
  FMPurchases = 96,
  FMPurchaseValue = 97,
  GMClicks = 98,
  GMImpressions = 99,
  GMCost = 100,
  GMRevenue = 101,
  GMPurchases = 102,
  GMPurchaseValue = 103,
  GMOrders = 104,
  OMPrice = 105,
  OIMQuantity = 107,
  OIMPrice = 108,
  ProductInventoryCount = 110,
  ItemGroupId = 111,
  InStockVariantCount = 112,
  OutOfStockVariantCount = 113,
  FMROAS = 114,
  FMCTR = 115,
  ItemId = 116,
  ProductVariantCustomLabel0 = 117,
  ProductVariantCustomLabel3 = 118,
  ProductVariantCustomLabel4 = 119,
  GAItemViews = 120,
  GAItemCheckedOut = 121,
  GAItemAddedToCart = 122,
  GAItemRevenue = 123,
  GAItemPurchases = 124,
  AddToCartRate = 125,
  TransactionRate = 126,
  CMCost = 127,
  CMWebsiteBlendedROAS = 128,
  CMWebsiteBlendedCRR = 129,
  CMGABlendedROAS = 130,
  CMCPS = 131,
  CMGACPS = 132,
  OrderCount = 133,
  ProductTitle = 134,
  ProductImageLink = 135,
  ProductStatus = 136,
  ProductDescription = 137,
  ProductVariantDescription = 138,
  FMCampaign = 139,
  GMCampaign = 140,
  GASessionCampaign = 141,
  GASessionMedium = 142,
  GASessionSource = 143,
  SMCampaign = 144,
  ItemType = 10001,
  ShopifyCollections = 156,
  ProductSalePrice = 157,
  StopLossExclusionByChannel = 178,
  StopLossExclusionByRule = 179,
  ProductTag = 180,
  FMAd = 181,
  SMAd = 182,
  GMOrganicImpressions = 184,
  GMOrganicPurchases = 185,
  GMOrganicClicks = 186
}

export const MinLimitForBulkValues: number = 10

export const productInsightsFixedColumn = [
  ProductInsightFields.ProductTitle,
  ProductInsightFields.ProductVariantTitle,
  ProductInsightFields.ProductImageLink,
  ProductInsightFields.ProductVariantImageLink
]

export const SELECTION_OPTIONS = ['Attributes', 'Metrics']

export enum SearchEngines {
  Google = 1,
  Facebook = 5,
  Shopify = 24,
  DeltaX = 42,
  GoogleAnalytics = 8,
  Snapchat = 30,
  AppsFlyer = 16,
  GoogleMerchantCenter = 73
}

export const SearchEngineNames: Record<SearchEngines, string> = {
  [SearchEngines.Google]: 'Google',
  [SearchEngines.Facebook]: 'Meta',
  [SearchEngines.Shopify]: 'Shopify',
  [SearchEngines.DeltaX]: 'DeltaX',
  [SearchEngines.GoogleAnalytics]: 'Google Analytics',
  [SearchEngines.Snapchat]: 'Snapchat',
  [SearchEngines.AppsFlyer]: 'AppsFlyer',
  [SearchEngines.GoogleMerchantCenter]: 'Google Merchant Center'
}

export function getChannelLogo(engineId?: number) {
  switch (engineId) {
    case SearchEngines.Google:
      return googleAdLogo
    case SearchEngines.Facebook:
      return metaLogo
    case SearchEngines.DeltaX:
      return deltaxLogo
    case SearchEngines.GoogleAnalytics:
      return googleAnalyticLogo
    case SearchEngines.Snapchat:
      return snapchatLogo
    case SearchEngines.AppsFlyer:
      return appsFlyerLogo
    case SearchEngines.GoogleMerchantCenter:
      return googleMerchantCenter
    default:
      return shopifyLogo
  }
}

export const DefaultAvailableChannels = [
  SearchEngines.Google,
  SearchEngines.Facebook,
  SearchEngines.Snapchat
]

export const AttributeIds = [
  ProductInsightFields.ProductVariantSKU,
  ProductInsightFields.ProductVariantTitle,
  ProductInsightFields.ProductVariantImageLink,
  ProductInsightFields.ProductPrice,
  ProductInsightFields.ProductBrand,
  ProductInsightFields.ProductType,
  ProductInsightFields.ProductVariantStatus,
  ProductInsightFields.ProductVariantColor,
  ProductInsightFields.ProductVariantGender,
  ProductInsightFields.ProductVariantMaterial,
  ProductInsightFields.ProductVariantAvailability,
  ProductInsightFields.ProductVariantPattern,
  ProductInsightFields.ProductCategory,
  ProductInsightFields.ProductVariantCurrency,
  ProductInsightFields.ProductVariantSize,
  ProductInsightFields.ItemGroupId,
  ProductInsightFields.ItemId,
  ProductInsightFields.ProductVariantCustomLabel0,
  ProductInsightFields.ProductVariantCustomLabel1,
  ProductInsightFields.ProductVariantCustomLabel2,
  ProductInsightFields.ProductVariantCustomLabel3,
  ProductInsightFields.ProductVariantCustomLabel4,
  ProductInsightFields.ProductTitle,
  ProductInsightFields.ProductImageLink,
  ProductInsightFields.ProductStatus,
  ProductInsightFields.ProductDescription,
  ProductInsightFields.ProductVariantDescription
]

export const MetricIds = [
  ProductInsightFields.PDFPurchases,
  ProductInsightFields.PDFRevenue,
  ProductInsightFields.PDFMGoal0,
  ProductInsightFields.PDFMGoal1,
  ProductInsightFields.PDFMGoal2,
  ProductInsightFields.PDFMGoal3,
  ProductInsightFields.PDFMGoal4,
  ProductInsightFields.PDFMGoal5,
  ProductInsightFields.PDFMGoal6,
  ProductInsightFields.PDFMGoal7,
  ProductInsightFields.PDFMGoal8,
  ProductInsightFields.PDFMGoal9,
  ProductInsightFields.PDFMGoal10,
  ProductInsightFields.PDFMGoal11,
  ProductInsightFields.PDFMGoal12,
  ProductInsightFields.PDFMGoal13,
  ProductInsightFields.PDFMGoal14,
  ProductInsightFields.PDFMGoal15,
  ProductInsightFields.PDFMGoal16,
  ProductInsightFields.PDFMGoal17,
  ProductInsightFields.PDFMGoal18,
  ProductInsightFields.PDFMGoal19,
  ProductInsightFields.PDFMGoal20,
  ProductInsightFields.PDFMGoal21,
  ProductInsightFields.PDFMGoal22,
  ProductInsightFields.PDFMGoal23,
  ProductInsightFields.PDFMGoal24,
  ProductInsightFields.PDFMGoal25,
  ProductInsightFields.PDFMGoal26,
  ProductInsightFields.PDFMGoal27,
  ProductInsightFields.PDFMGoal28,
  ProductInsightFields.PDFMGoal29,
  ProductInsightFields.PDFMGoal30,
  ProductInsightFields.PDFMGoal31,
  ProductInsightFields.PDFMGoal32,
  ProductInsightFields.PDFMGoal33,
  ProductInsightFields.PDFMGoal34,
  ProductInsightFields.PDFMGoal35,
  ProductInsightFields.PDFMGoal36,
  ProductInsightFields.PDFMGoal37,
  ProductInsightFields.PDFMGoal38,
  ProductInsightFields.PDFMGoal39,
  ProductInsightFields.PDFMGoal40,
  ProductInsightFields.PDFMGoalValue11,
  ProductInsightFields.PDFMGoalValue12,
  ProductInsightFields.PDFMGoalValue13,
  ProductInsightFields.PDFMGoalValue14,
  ProductInsightFields.PDFMGoalValue15,
  ProductInsightFields.PDFMGoalValue16,
  ProductInsightFields.PDFMGoalValue17,
  ProductInsightFields.PDFMGoalValue18,
  ProductInsightFields.PDFMGoalValue19,
  ProductInsightFields.PDFMGoalValue20,
  ProductInsightFields.PDFMStage1,
  ProductInsightFields.PDFMStage2,
  ProductInsightFields.PDFMStage3,
  ProductInsightFields.PDFMStage4,
  ProductInsightFields.PDFMStage5,
  ProductInsightFields.PDFMStage6,
  ProductInsightFields.PDFMStage7,
  ProductInsightFields.PDFMStage8,
  ProductInsightFields.PDFMStage9,
  ProductInsightFields.PDFMStage10,
  ProductInsightFields.PDFMStage11,
  ProductInsightFields.PDFMStage12,
  ProductInsightFields.PDFMStage13,
  ProductInsightFields.PDFMStage14,
  ProductInsightFields.PDFMStage15,
  ProductInsightFields.PDFMStage16,
  ProductInsightFields.PDFMxConversionsWeb,
  ProductInsightFields.PDFMxConversionsIos,
  ProductInsightFields.PDFMxConversionsAndroid,
  ProductInsightFields.PDFMxRevenueWeb,
  ProductInsightFields.PDFMxRevenueAndroid,
  ProductInsightFields.PDFMxRevenueIos,
  ProductInsightFields.FMClicks,
  ProductInsightFields.FMImpressions,
  ProductInsightFields.FMCost,
  ProductInsightFields.FMPurchases,
  ProductInsightFields.FMPurchaseValue,
  ProductInsightFields.GMClicks,
  ProductInsightFields.GMImpressions,
  ProductInsightFields.GMCost,
  ProductInsightFields.GMRevenue,
  ProductInsightFields.GMPurchases,
  ProductInsightFields.GMPurchaseValue,
  ProductInsightFields.GMOrders,
  ProductInsightFields.OMPrice,
  ProductInsightFields.OIMQuantity,
  ProductInsightFields.OIMPrice,
  ProductInsightFields.ProductInventoryCount,
  ProductInsightFields.InStockVariantCount,
  ProductInsightFields.OutOfStockVariantCount,
  ProductInsightFields.FMROAS,
  ProductInsightFields.FMCTR,
  ProductInsightFields.GAItemViews,
  ProductInsightFields.GAItemCheckedOut,
  ProductInsightFields.GAItemAddedToCart,
  ProductInsightFields.GAItemRevenue,
  ProductInsightFields.GAItemPurchases,
  ProductInsightFields.AddToCartRate,
  ProductInsightFields.TransactionRate,
  ProductInsightFields.CMCost,
  ProductInsightFields.CMWebsiteBlendedROAS,
  ProductInsightFields.CMWebsiteBlendedCRR,
  ProductInsightFields.CMGABlendedROAS,
  ProductInsightFields.CMCPS,
  ProductInsightFields.CMGACPS,
  ProductInsightFields.OrderCount,
  ProductInsightFields.GMOrganicClicks,
  ProductInsightFields.GMOrganicImpressions,
  ProductInsightFields.GMOrganicPurchases
]

export const OperatorConstant: Field[] = [
  { name: 'None', value: Operators.None },
  { name: 'Equals', value: Operators.Equals },
  { name: 'Not Equal', value: Operators.NotEquals },
  { name: 'Less Than', value: Operators.LessThan },
  { name: 'Less Than Or Equals', value: Operators.LessThanOrEquals },
  { name: 'Greater Than', value: Operators.GreaterThan },
  { name: 'Greater Than Or Equals', value: Operators.GreaterThanOrEquals },
  { name: 'Contains', value: Operators.Contains },
  { name: 'Not Contains', value: Operators.NotContains },
  { name: 'Is Not Present', value: Operators.IsNull },
  { name: 'Is Present', value: Operators.IsNotNull },
  { name: 'Between', value: Operators.Between },
  { name: 'IN', value: Operators.IN },
  { name: 'Not IN', value: Operators.NotIN },
  { name: 'Exists IN', value: Operators.ExistsIn },
  { name: 'Not Exists IN', value: Operators.NotExistsIn }
]

export const MetricOperators: Field[] = [
  { name: 'Equals', value: Operators.Equals },
  { name: 'Not Equal', value: Operators.NotEquals },
  { name: 'Less Than', value: Operators.LessThan },
  { name: 'Less Than Or Equals', value: Operators.LessThanOrEquals },
  { name: 'Greater Than', value: Operators.GreaterThan },
  { name: 'Greater Than Or Equals', value: Operators.GreaterThanOrEquals },
  { name: 'Is Not Present', value: Operators.IsNull },
  { name: 'Is Present', value: Operators.IsNotNull },
  { name: 'Between', value: Operators.Between }
]

export const AttributeOperators: Field[] = [
  { name: 'Equals', value: Operators.Equals },
  { name: 'Not Equal', value: Operators.NotEquals },
  { name: 'Contains', value: Operators.Contains },
  { name: 'Not Contains', value: Operators.NotContains },
  { name: 'Is Not Present', value: Operators.IsNull },
  { name: 'Is Present', value: Operators.IsNotNull }
]

export const AttributeOperatorsWithValueLookupTrue: Field[] = [
  { name: 'Equals', value: Operators.Equals },
  { name: 'Not Equal', value: Operators.NotEquals },
  { name: 'Contains', value: Operators.Contains },
  { name: 'Not Contains', value: Operators.NotContains },
  { name: 'Is Not Present', value: Operators.IsNull },
  { name: 'Is Present', value: Operators.IsNotNull },
  { name: 'IN', value: Operators.IN },
  { name: 'Not IN', value: Operators.NotIN }
]

export const ChannelAttributeOperators: Field[] = [
  { name: 'Equals', value: Operators.Equals },
  { name: 'Not Equal', value: Operators.NotEquals },
  { name: 'IN', value: Operators.IN },
  { name: 'Not IN', value: Operators.NotIN }
]

export const RuleOperator = Object.freeze({ AND: 'AND', OR: 'OR' })

export const ToggleList: Toggle[] = [
  { label: RuleOperator.AND, value: RuleOperator.AND },
  { label: RuleOperator.OR, value: RuleOperator.OR }
]

export enum DurationType {
  DYNAMIC = 1,
  FIXED = 2
}

export enum FilterTypes {
  ATTRIBUTE = 1,
  METRIC = 2,
  CUSTOM = 3,
  CHANNEL_ATTRIBUTE = 4
}

export enum DataTypesEnum {
  StringType = 1,
  NumberType = 2
}

export const DefaultDuration = 7

export const SampleRuleJson: RulesJson = {
  groups: [
    {
      operator: RuleOperator.AND,
      filterType: FilterTypes.ATTRIBUTE,
      rules: [
        {
          operator: RuleOperator.AND,
          durationType: DurationType.FIXED,
          duration: null,
          filters: [
            {
              field: undefined,
              operator: undefined,
              value: undefined,
              isValid: false
            }
          ],
          isFiltersEmpty: true,
          isValid: true
        }
      ],
      isRulesEmpty: true,
      isValid: false
    },
    {
      operator: RuleOperator.AND,
      filterType: FilterTypes.METRIC,
      rules: [
        {
          operator: RuleOperator.AND,
          durationType: DurationType.DYNAMIC,
          duration: DefaultDuration,
          startDate: getDateString(new Date()),
          endDate: getDateString(new Date()),
          filters: [
            {
              field: undefined,
              operator: undefined,
              value: undefined,
              isValid: false
            }
          ],
          isFiltersEmpty: true,
          isValid: false
        }
      ],
      isRulesEmpty: true,
      isValid: false
    }
  ],
  isRuleGroupsEmpty: true,
  isValid: false
}

export const DateOptions = [
  {
    name: 'Yesterday',
    value: 1
  },
  {
    name: 'Last 7 days',
    value: 7
  },
  {
    name: 'Last 15 days',
    value: 15
  },
  {
    name: 'Last 30 days',
    value: 30
  },
  {
    name: 'Last 60 days',
    value: 60
  },
  {
    name: 'Last 90 days',
    value: 90
  },
  {
    name: 'Custom',
    value: null
  }
]

export const MultiValueOperators = new Set<number | undefined>([
  Operators.IN,
  Operators.NotIN,
  Operators.ExistsIn,
  Operators.NotExistsIn
])

export const ReferenceBasedFields = new Set<number | number>([
  ProductInsightFields.ShopifyCollections,
  ProductInsightFields.StopLossExclusionByChannel,
  ProductInsightFields.StopLossExclusionByRule,
  ProductInsightFields.ProductTag,
  ProductInsightFields.FMCampaign,
  ProductInsightFields.GMCampaign,
  ProductInsightFields.SMCampaign,
  ProductInsightFields.FMAd,
  ProductInsightFields.SMAd
])

export const ProductParametersRequiringIdMapping = [
  ProductInsightFields.ProductVariantStatus,
  ProductInsightFields.ProductVariantAvailability,
  ProductInsightFields.ProductStatus,
  ...ReferenceBasedFields
]
